export default __webpack_public_path__ + "static/media/process1.6ab93170.png";